import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

// for all options read: https://www.i18next.com/overview/configuration-options
i18n.use(initReactI18next).use(HttpApi).init({
    // @ts-ignore
    debug: __DEV__,
    // @ts-ignore
    lng: appConfig.lang,
    fallbackLng: 'cs',
    backend: {
        // @ts-ignore
        loadPath: `${serverContextPath}/lang/messages_{{lng}}.json`
    },
    react: {
        useSuspense: false,
    }
});

export default i18n;
